import { render } from "./TheSideMenu.vue?vue&type=template&id=de2e6736&scoped=true"
import script from "./TheSideMenu.vue?vue&type=script&lang=js"
export * from "./TheSideMenu.vue?vue&type=script&lang=js"

import "./TheSideMenu.vue?vue&type=style&index=0&id=de2e6736&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de2e6736"]])

export default __exports__